<script setup lang="ts">
defineProps({
    question: { type: String, required: true },
    slug: { type: String, required: true },
});
</script>

<template>
    <NuxtLink :id="slug" class="scroll-my-[calc(var(--header-total-height)+1rem)] py-2 text-base font-semibold hover:underline" :to="`#${slug}`">
        {{ question }}
    </NuxtLink>
    <div class="text-dimmed pt-1.5 pb-3 text-sm"><slot /></div>
</template>
